import * as React from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import styled from 'styled-components'
import { useDispatch } from 'redux-react-hook'
import { Login } from './login'
import Report from './report'
import ReportDetail from './report_detail'
import Inquiry from './inquiry'
import InquiryForm from './inquiry_form'
import InquiryDetail from './inquiry_detail'
import Share from './share'
import PasswordChangeForm from './password_change'
import { Spinner } from '../organisms/spinner'
import { getSession } from '../../actions/auth.action'
import { Color } from '../../constants/app.constant'
import Notifications, { notify } from 'react-notify-toast'
import useGetState from '../../hooks/use-get-state'
import history from '../utils/history'
const { useEffect } = React
const App: React.SFC = () => {
  const dispatch = useDispatch()
  const {
    state: { app, auth },
  } = useGetState()
  useEffect(
    () => {
      if (app.error !== '') notify.show(app.error, 'error', 1000)
    },
    [app.error]
  )
  useEffect(
    () => {
      if (app.success !== '') notify.show(app.success, 'success', 1000)
    },
    [app.success]
  )
  useEffect(
    () => {
      if (!history.location.pathname.match('share') && !auth.user)
        dispatch(getSession())
    },
    [history.location.pathname] // eslint-disable-line
  )
  return (
    <Wrapper>
      <Router history={history}>
        <Switch>
          <Route exact={true} path="/" component={Login} />
          <Route path="/report" component={Report} />
          <Route path="/report_detail/:reportId" component={ReportDetail} />
          <Route path="/inquiry" component={Inquiry} />
          <Route path="/inquiry_form" component={InquiryForm} />
          <Route path="/inquiry_detail/:inquiryId" component={InquiryDetail} />
          <Route path="/share/:key" component={Share} />
          <Route path="/password_change" component={PasswordChangeForm} />
        </Switch>
      </Router>
      <Notifications />
      {app.loading && <Spinner />}
    </Wrapper>
  )
}

export default App
const Wrapper = styled.div`
  background-color: ${Color.VERY_LIGHT_GRAY_3};
`



// WEBPACK FOOTER //
// ./src/components/pages/index.tsx